module.exports = __webpack_public_path__ + "img/julio_dark_mode.16db4feb.png";